export const curl = [
  '#141d43', '#182d4c', '#1b3c55', '#1c4a5e', '#1a5b69', '#156a71', '#107977', '#17887c',
  '#349780', '#54a384', '#73ae8c', '#8fb997', '#adc6a9', '#c5d2bb', '#dcdfd0', '#f3ede7',
  '#f8ebe6', '#f0d7cb', '#e9c3b1', '#e4b099', '#de9982', '#d88571', '#d17167', '#c75e61',
  '#b84b60', '#aa3c60', '#9a2d60', '#882160', '#72185c', '#5d1453', '#481146', '#330d35'
]

export default {
  curl
}
